/* tslint:disable */
/* eslint-disable */
/**
 * User service API
 * Service for user management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NewAidDto
 */
export interface NewAidDto {
    /**
     * 
     * @type {string}
     * @memberof NewAidDto
     */
    aid: string;
}

/**
 * Check if a given object implements the NewAidDto interface.
 */
export function instanceOfNewAidDto(value: object): boolean {
    if (!('aid' in value)) return false;
    return true;
}

export function NewAidDtoFromJSON(json: any): NewAidDto {
    return NewAidDtoFromJSONTyped(json, false);
}

export function NewAidDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NewAidDto {
    if (json == null) {
        return json;
    }
    return {
        
        'aid': json['aid'],
    };
}

export function NewAidDtoToJSON(value?: NewAidDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'aid': value['aid'],
    };
}

